import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgVisa = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 36" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#979797">
      <path d="M55.367 18.306a11.155 11.155 0 0 0-7.207-2.626c-6.186 0-11.2 5.014-11.2 11.2 0 3.351 1.472 6.359 3.804 8.411" />
      <path d="M51.908 35.202c1.137-2.05 1.852-5.019 1.852-8.322 0-6.186-2.507-11.2-5.6-11.2-3.093 0-5.6 5.014-5.6 11.2 0 3.31.718 6.286 1.86 8.336m-7.144-8.648h18.077M48.464 15.53v19.724" />
      <path d="M2 .5A1.5 1.5 0 0 0 .5 2v31.84a1.5 1.5 0 0 0 1.5 1.5h52a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 54 .5H2z" />
      <path d="M4.98 4.98h13.56V21.9H4.98zm18.236 2.768h25.622m-25.622 4.48h25.622" />
    </g>
  </svg>
);
const Memo = memo(SvgVisa);
export default Memo;
